
import { z } from "zod";

export const TicketSubcategoryValues = ["ADDITIONAL_FUNDING_REQUIRED", "ADDITIONAL_SOW", "AGREEMENT_SENT_ON_MISSING_REPORTABLE_FSD", "ACCOUNT_FOR_WARRANTY_COVERAGE", "ADDRESS_HOMEOWNER_SOW_REJECTION", "ADD_HOMEOWNER_PHONE_FOR_UPSELL_DEAL", "AHJ_ADDITIONAL_REQUIREMENTS", "AHJ_AVAILABILITY_ISSUES", "AHJ_CONFIRM_PASS", "AHJ_ISSUE_PERMIT", "AHJ_NO_SHOW", "AHJ_SCHEDULE_INSPECTION", "ANSWER_INFORMATION_REQUEST", "APPROVE_NTP_FUNDING", "ASSIGN_SUBCONTRACTOR", "ATTORNEY_GENERAL", "AVAILABILITY_CHECK", "BBB", "CAD_CORRECTION_REQUIRED_PER_AHJ", "CAD_ISSUE", "CAD_MISSING_INCORRECT_CAD", "CAD_UPDATED_STAMP_STRUCTURAL_LETTER", "CANCELLATION_REQUEST", "CHANGED_SOW", "CHANGES_TO_ASSIGNMENT_DISPATCH", "CHECK_PAYMENT", "CLARIFY_SOW", "CLEANUP_ISSUE", "COLLECT_FUNDING_FROM_HOMEOWNER", "COLLECT_PV_INSTALL_SCHEDULE_DATE", "COLLECT_ROOF_WORK_SCHEDULE_DATE", "COMMUNICATION", "COMMUNICATE_BLOCKER_OR_DELAY", "COMPLETE_REDESIGN", "COMPLIANCE_SAFETY_CONCERN", "CONFIRM_PV_INSTALL_COMPLETION", "CONFIRM_ROOF_WORK_COMPLETION_DATE", "CONFIRM_SCHEDULE_ASSIGNMENT", "CONFIRM_WARRANTY_COVERAGE", "CONTACT_CREW_LEAD_FOR_UNRESPONSIVENESS", "CONTACT_INFO_UPDATE", "CONTACT_UNSATISFIED_HO_AND_PROPOSE_RESOLUTION", "CONTACT_UNSATISFIED_HO_FROM_SURVEY", "CONTRACT_HELP_QUESTIONS", "CONTRACT_REVIEW", "CONTRACTOR_AVAILABILITY_ISSUES", "CONFIRM_CANCELLATION_WITH_PARTNER", "CONFIRM_DATE", "CONFIRM_DATE_ACTIVE_ESCALATION", "CONTACT_UNRESPONSIVE_CUSTOMER", "CONTRACTOR_FOLLOW_UP", "PROVIDE_INFORMATION_UPDATE", "SUBMIT_DOCUMENTATION", "COORDINATE_MATERIALS_PLACEMENT", "COORDINATE_MEDIA_SOCIAL_RESPONSE", "CORPORATE_PARTNER_FOLLOW_UP", "CORPORATE_SOW_CHANGES", "CORRECT_WRONG_MATERIALS_AND_REORDER", "CREATE_QUOTE", "CREDIT_DEBIT_ADJUSTMENT", "CREW_ARRIVAL", "CUSTOMER_CONTRACTOR_FOLLOW_UP", "CUSTOMER_CORPORATE_PARTNER_FOLLOW_UP", "CUSTOMER_HOMEOWNER_FOLLOW_UP", "CUSTOMER_INTERNAL_FOLLOW_UP", "CUSTOMER_PROCESS_FEEDBACK", "CUSTOMER_REFERRAL", "CUSTOMER_SALES_FOLLOW_UP", "CUSTOMER_SUBCONTRACTOR_FEEDBACK", "DELAY_IN_RECEIVING_PROOF_OF_PASS", "DUMPSTER_TRUCK_MATERIALS_PLACEMENT", "ENGAGE_LEGAL_COUNSEL", "ESCALATE_REDESIGN", "ESCALATE_TO_EXECUTIVE_TEAM", "ESCALATE_UNPAID_WORK", "ESCROW_FUNDING", "ESCROW_ISSUE", "ESCROW_SETUP", "ESTIMATING_FEEDBACK", "EXPECTATION_MISALIGNMENT", "EXECUTIVE_ESCALATION", "EXTERIOR_DAMAGE", "FIELD_FOLLOW_UP_WITH_PARTNER", "FINALIZE_CHANGE_ORDER_PAYMENT", "FINANCING_HELP_QUESTIONS", "FINANCING_ISSUE", "FIX_INTERNAL_DATA_PROCESS_ISSUE", "FIX_MISQUOTE", "FIX_PRE_NEGOTIATED_QUOTE", "FIX_QUOTE", "FOLLOW_UP_ON_REFERRAL", "GENERAL_INQUIRY", "HIC_ISSUE", "HOLD_PRICING_CONVERSATION_WITH_CONTRACTOR", "HOMEOWNER_ARRANGEMENT_CLARIFICATION", "HOMEOWNER_CAN_T_FIND_LINK_DOCS", "HOMEOWNER_COLLECT_REDESIGN_AVAILABILITY", "HOMEOWNER_CONFIRM_PARTNER_CANCELLATION", "HOMEOWNER_CONFIRM_SOW", "HOMEOWNER_FOLLOW_UP", "HOMEOWNER_PROVIDE_DOCUMENTS", "HOMEOWNER_PROVIDE_INFORMATION_UPDATE", "HOMEOWNER_SCHEDULE_ACCESS", "HOMEOWNER_SOW_REJECTION", "INGESTION_ISSUE", "INSPECTION_AVAILABILITY_CHECK", "INSPECTION_REQUEST_POST_INSTALL", "INSPECTION_RESCHEDULE", "INSPECTION_SUBCONTRACTOR_NO_SHOW", "INSPECTIONS", "INSURANCE_ITEMIZATION", "INSURANCE_PARTNER_FOLLOW_UP", "INSURANCE_PAYMENT", "INTERIOR_DAMAGE", "INTERNAL_FOLLOW_UP", "INVESTIGATE_WORKMANSHIP_AND_SCHEDULE_REPAIR", "INVOICE_REQUEST", "LEAKS_INTERIOR_DAMAGE", "LEGAL", "LETTER_OF_AUTHORIZATION", "LICENSING_BOARD", "MATERIAL_REQUEST", "MATERIALS_DELAY", "MISC_COMMUNICATION_WITH_HOMEOWNER", "MISSING_INFO_FROM_SUBCONTRACTOR", "MISSING_SOW_INFO", "NEED_SOW_CONFIRMATION", "NEED_TO_FINALIZE_SALES_PROCESS", "NEED_TO_SCHEDULE_APPOINTMENT", "NEEDS_REASSIGNMENT", "NEWS_MEDIA", "NO_ACTION_NEEDED", "NO_CALL_NO_SHOW", "NO_SALES_FOLLOW_UP_SCHEDULED", "NTP_DECISION", "NTP_ISSUE", "OBTAIN_MISSING_PHOTOS", "OPEN_ESCALATION", "ORDER_MATERIALS", "OTHER", "PARTNER_HIC", "PAYMENT_INQUIRY", "PENDING_HOA_APPROVAL", "PERMIT_FINAL_INSPECTION", "PERMIT_INSPECTION_ISSUE", "PERMITTING", "PLACE_WORK_ON_HOLD", "POOR_WORKMANSHIP", "PORTAL_INTEGRATION_ISSUE", "PRE_EXISTING_PERMITS", "PROCESS_CANCELLATION", "PROCESS_FEEDBACK", "PROCESS_REFUND_ADJUSTMENT", "PROCESS_SOW_CHANGE", "PRODUCE_ITEMIZED_RECEIPT_INVOICE", "PROVIDE_CAD_STAMP_LOA", "PROVIDE_CAD", "PROVIDE_CUSTOMER_UPDATE", "PROVIDE_ESTIMATE_CLARIFICATION", "PROVIDE_INSURANCE_ITEMIZATION", "PROVIDE_LOA", "PROVIDE_REQUESTED_DOCUMENTS", "PROVIDE_STAMP", "PROVIDE_UPDATE", "QUOTE_ISSUE", "REASSIGN_SUBCONTRACTOR", "RECORD_FEEDBACK", "RECORD_PAYMENT", "REDESIGN", "REFERRAL_CONTRACTOR_FOLLOW_UP", "REFERRAL_CORPORATE_PARTNER_FOLLOW_UP", "REFERRAL_HOMEOWNER_FOLLOW_UP", "REFERRAL_INTERNAL_FOLLOW_UP", "REFERRAL_PROCESS_FEEDBACK", "REFERRAL_SALES_FOLLOW_UP", "REFERRAL_SUBCONTRACTOR_FEEDBACK", "REFUND_REQUEST", "REINSTATE_CANCELLED_JOB", "REJECT_FINDINGS", "RELATIONSHIP_ESCALATION", "REMINDER_CONTRACTOR_FOLLOW_UP", "REMINDER_CORPORATE_PARTNER_FOLLOW_UP", "REMINDER_HOMEOWNER_FOLLOW_UP", "REMINDER_INTERNAL_FOLLOW_UP", "REMINDER_SALES_FOLLOW_UP", "REPORT_SAFETY_CONCERN_AND_PAUSE_WORK", "REQUEST_FOR_CANCELLATION", "REQUEST_FOR_QUOTE", "REQUEST_FOR_REPAIRS", "REQUEST_FOR_SITE_ASSESSMENT", "REQUEST_FOR_UNCANCELLATION", "REQUEST_FOR_UPDATE", "REQUEST_REPORTABLE_FSD", "REQUEST_NEW_ITEL_SITE_VISIT", "REQUEST_REPORTING_DELAY", "REQUEST_TO_RESUME_WORK", "RERUN_CUSTOMER_CREDIT", "REQUESTED_HOLD_DELAY", "RESCHEDULE", "RESOLVE_FUNDING_NOT_FINALIZED", "RESOLVE_SCOPE_DISPUTE", "RESOLVE_SCOPE_DISPUTE_WITH_CONTRACTOR", "REVIEW_ESTIMATED_START_WEEK_EXPECTATIONS", "REVIEW_REOPENED_BID", "REVISE_QUOTE_ESTIMATE", "RESPOND_TO_BBB_LICENSING_AG", "RESUME_WORK", "ROOF_LEAK", "ROOF_MATERIAL_DAMAGE", "SALES_FOLLOW_UP", "SALES_FOLLOW_UP_CALL", "SALES_FOLLOW_UP_EMAIL", "SALES_FOLLOW_UP_OTHER", "SALES_FOLLOW_UP_SMS", "SALES_FOLLOWUP_PARTNER_CANCELLATION", "SALES_TRAINING", "SCHEDULE_CLEANUP", "SCHEDULE_DAMAGE_ASSESSMENT", "SCHEDULE_LEAK_ASSESSMENT", "SCHEDULE_POST_INSTALL_INSPECTION", "SCHEDULE_SITE_VISIT_REINSPECTION", "SCHEDULE_TRAINING", "SCHEDULE_WORK", "SCHEDULING", "SCOPE_DISPUTE", "SEND_INVOICE", "SEND_REMINDER_TO_STAKEHOLDER", "SETTLE_FIRST_JOB_PRICE_REJECTION", "SHIP_MATERIALS", "TRACK_MATERIAL_REQUEST", "ESCALATE_MATERIAL_REQUEST_FSA", "REVIEW_POST_NTP_SUNRUN_WO", "COORDINATE_CREW_PARTNER_MATERIALS_PICKUP", "COMMUNICATE_WITH_PARTNER_RE_QUOTE", "REQUEST_NEW_ASSIGNMENT_SHELL", "PROCESS_SITE_VISIT_CANCELLATION", "RESOLVE_FUNDING_STIPULATIONS", "RESOLVE_FAILED_SUNRUN_AUTOMATION", "SUNRUN_FINANCING", "SUNRUN_FINDINGS_REJECTION", "SUNRUN_INVOICE_REJECTION", "CONFIRM_PHYSICAL_CHECK_RECEIPT", "REQUEST_WESTHILL_PAYMENT_WITHOUT_COC", "SUBMIT_WESTHILL_INVOICE_COC", "REVIEW_COLLECTIONS_ITEM", "SOCIAL_MEDIA", "SOURCE_CONTRACTOR", "SOW_CHANGE_ISSUE", "SOW_CHANGES", "SOW_CLARIFICATION", "SOW_DISCREPANCIES", "SOW_QUESTIONS", "STATUS_UPDATE", "STRUCTURAL_DAMAGE", "SUBCONTRACTOR_FEEDBACK", "SUBCONTRACTOR_NO_SHOW", "UNAUTHORIZED_REQUEST", "UNPERMITTED_STRUCTURE", "UNRESPONSIVE_CREW", "UNSATISFIED_HOMEOWNER", "UPDATE_CONTACT_INFORMATION", "UPDATE_REMI_APP", "UPDATE_WORK_ORDER", "VIP_ACCOUNT", "WARRANTY_COVERAGE_QUESTION", "WESTHILL_FNOL_APPROVAL_OVERDUE", "WORK_AVAILABILITY_CHECK", "WORK_RESCHEDULE", "WORK_SUBCONTRACTOR_NO_SHOW", "WORKMANSHIP", "WORKMANSHIP_COMPLAINT", "WRONG_MATERIALS_USED", "PIPELINE_MANAGEMENT", "PROJECT_COMPLETION_CALL", "SOURCE_SPECIALTY_PRICING", "SALES_OPERATIONS_PARTNERS_QUESTION"] as const;
export const TicketSubcategorySchema = z.enum(TicketSubcategoryValues);
export const TicketSubcategory = TicketSubcategorySchema.enum;
export type TicketSubcategory = (typeof TicketSubcategoryValues)[number];
export const TicketSubcategoryDisplayNames = { "ADDITIONAL_FUNDING_REQUIRED": "Additional funding required",
"ADDITIONAL_SOW": "Additional SOW",
"AGREEMENT_SENT_ON_MISSING_REPORTABLE_FSD": "Agreement sent on missing reportable FSD",
"ACCOUNT_FOR_WARRANTY_COVERAGE": "Account for warranty coverage",
"ADDRESS_HOMEOWNER_SOW_REJECTION": "Address SOW with homeowner",
"ADD_HOMEOWNER_PHONE_FOR_UPSELL_DEAL": "Add homeowner phone for upsell deal",
"AHJ_ADDITIONAL_REQUIREMENTS": "AHJ additional requirements",
"AHJ_AVAILABILITY_ISSUES": "AHJ availability issues",
"AHJ_CONFIRM_PASS": "AHJ: Confirm pass",
"AHJ_ISSUE_PERMIT": "AHJ: Issue permit",
"AHJ_NO_SHOW": "AHJ no-show",
"AHJ_SCHEDULE_INSPECTION": "AHJ: Schedule inspection",
"ANSWER_INFORMATION_REQUEST": "Answer information request",
"APPROVE_NTP_FUNDING": "Approve NTP/funding",
"ASSIGN_SUBCONTRACTOR": "Assign subcontractor",
"ATTORNEY_GENERAL": "Attorney general",
"AVAILABILITY_CHECK": "Availability check",
"BBB": "BBB",
"CAD_CORRECTION_REQUIRED_PER_AHJ": "CAD (correction required per AHJ)",
"CAD_ISSUE": "CAD issue",
"CAD_MISSING_INCORRECT_CAD": "CAD (missing/incorrect CAD)",
"CAD_UPDATED_STAMP_STRUCTURAL_LETTER": "CAD (updated stamp and/or structural letter)",
"CANCELLATION_REQUEST": "Cancellation request",
"CHANGED_SOW": "Changed SOW",
"CHANGES_TO_ASSIGNMENT_DISPATCH": "Changes to assignment/dispatch",
"CHECK_PAYMENT": "Check payment",
"CLARIFY_SOW": "Clarify SOW",
"CLEANUP_ISSUE": "Cleanup issue",
"COLLECT_FUNDING_FROM_HOMEOWNER": "Collect funding from homeowner",
"COLLECT_PV_INSTALL_SCHEDULE_DATE": "Collect PV install schedule date",
"COLLECT_ROOF_WORK_SCHEDULE_DATE": "Collect roof work schedule date",
"COMMUNICATION": "Communication",
"COMMUNICATE_BLOCKER_OR_DELAY": "Communicate blocker or delay",
"COMPLETE_REDESIGN": "Complete redesign",
"COMPLIANCE_SAFETY_CONCERN": "Compliance / safety concern",
"CONFIRM_PV_INSTALL_COMPLETION": "Confirm PV install completion",
"CONFIRM_ROOF_WORK_COMPLETION_DATE": "Confirm roof work completion date",
"CONFIRM_SCHEDULE_ASSIGNMENT": "Confirm assignment",
"CONFIRM_WARRANTY_COVERAGE": "Confirm warranty coverage",
"CONTACT_CREW_LEAD_FOR_UNRESPONSIVENESS": "Contact crew lead for unresponsiveness",
"CONTACT_INFO_UPDATE": "Contact info update",
"CONTACT_UNSATISFIED_HO_AND_PROPOSE_RESOLUTION": "Contact unsatisfied HO and propose resolution",
"CONTACT_UNSATISFIED_HO_FROM_SURVEY": "Contact unsatisfied HO from survey",
"CONTRACT_HELP_QUESTIONS": "Contract help / questions",
"CONTRACT_REVIEW": "Contract review",
"CONTRACTOR_AVAILABILITY_ISSUES": "Contractor availability issues",
"CONFIRM_CANCELLATION_WITH_PARTNER": "Confirm cancellation with partner",
"CONFIRM_DATE": "Confirm date",
"CONFIRM_DATE_ACTIVE_ESCALATION": "Confirm date (active escalation)",
"CONTACT_UNRESPONSIVE_CUSTOMER": "Contact unresponsive homeowner",
"CONTRACTOR_FOLLOW_UP": "Contractor follow-up",
"PROVIDE_INFORMATION_UPDATE": "Provide information/update",
"SUBMIT_DOCUMENTATION": "Submit documentation",
"COORDINATE_MATERIALS_PLACEMENT": "Coordinate materials placement",
"COORDINATE_MEDIA_SOCIAL_RESPONSE": "Coordinate media/social response",
"CORPORATE_PARTNER_FOLLOW_UP": "Corporate partner follow-up",
"CORPORATE_SOW_CHANGES": "Corporate SOW changes",
"CORRECT_WRONG_MATERIALS_AND_REORDER": "Correct wrong materials and reorder",
"CREATE_QUOTE": "Create quote/estimate",
"CREDIT_DEBIT_ADJUSTMENT": "Credit/debit adjustment",
"CREW_ARRIVAL": "Crew arrival",
"CUSTOMER_CONTRACTOR_FOLLOW_UP": "Customer contractor follow-up",
"CUSTOMER_CORPORATE_PARTNER_FOLLOW_UP": "Customer corporate partner follow-up",
"CUSTOMER_HOMEOWNER_FOLLOW_UP": "Customer homeowner follow-up",
"CUSTOMER_INTERNAL_FOLLOW_UP": "Customer internal follow-up",
"CUSTOMER_PROCESS_FEEDBACK": "Customer process feedback",
"CUSTOMER_REFERRAL": "Customer referral",
"CUSTOMER_SALES_FOLLOW_UP": "Customer sales follow-up",
"CUSTOMER_SUBCONTRACTOR_FEEDBACK": "Customer subcontractor feedback",
"DELAY_IN_RECEIVING_PROOF_OF_PASS": "Delay in receiving proof of pass",
"DUMPSTER_TRUCK_MATERIALS_PLACEMENT": "Dumpster/truck/materials placement",
"ENGAGE_LEGAL_COUNSEL": "Engage legal counsel",
"ESCALATE_REDESIGN": "Escalate redesign",
"ESCALATE_TO_EXECUTIVE_TEAM": "Escalate to executive team",
"ESCALATE_UNPAID_WORK": "Escalate unpaid work",
"ESCROW_FUNDING": "Escrow funding",
"ESCROW_ISSUE": "Escrow issue",
"ESCROW_SETUP": "Escrow setup",
"ESTIMATING_FEEDBACK": "Estimating feedback",
"EXPECTATION_MISALIGNMENT": "Expectation misalignment",
"EXECUTIVE_ESCALATION": "Executive escalation",
"EXTERIOR_DAMAGE": "Exterior damage",
"FIELD_FOLLOW_UP_WITH_PARTNER": "Field follow-up with partner",
"FINALIZE_CHANGE_ORDER_PAYMENT": "Finalize change order payment",
"FINANCING_HELP_QUESTIONS": "Financing help / questions",
"FINANCING_ISSUE": "Financing issue",
"FIX_INTERNAL_DATA_PROCESS_ISSUE": "Fix internal data/process issue",
"FIX_MISQUOTE": "Fix misquote",
"FIX_PRE_NEGOTIATED_QUOTE": "Fix pre-negotiated quote",
"FIX_QUOTE": "Fix quote",
"FOLLOW_UP_ON_REFERRAL": "Follow up on referral",
"GENERAL_INQUIRY": "General inquiry",
"HIC_ISSUE": "HIC issue",
"HOLD_PRICING_CONVERSATION_WITH_CONTRACTOR": "Hold pricing conversation with contractor",
"HOMEOWNER_ARRANGEMENT_CLARIFICATION": "Homeowner arrangement clarification",
"HOMEOWNER_CAN_T_FIND_LINK_DOCS": "Homeowner can't find link/docs",
"HOMEOWNER_COLLECT_REDESIGN_AVAILABILITY": "Collect redesign availability",
"HOMEOWNER_CONFIRM_PARTNER_CANCELLATION": "Confirm partner cancellation",
"HOMEOWNER_CONFIRM_SOW": "Homeowner: Confirm SOW",
"HOMEOWNER_FOLLOW_UP": "Homeowner follow-up",
"HOMEOWNER_PROVIDE_DOCUMENTS": "Homeowner: Provide documents",
"HOMEOWNER_PROVIDE_INFORMATION_UPDATE": "Homeowner: Provide information/update",
"HOMEOWNER_SCHEDULE_ACCESS": "Schedule access with homeowner",
"HOMEOWNER_SOW_REJECTION": "Homeowner SOW rejection",
"INGESTION_ISSUE": "Ingestion issue",
"INSPECTION_AVAILABILITY_CHECK": "Inspection availability check",
"INSPECTION_REQUEST_POST_INSTALL": "Inspection request (post-install)",
"INSPECTION_RESCHEDULE": "Inspection reschedule",
"INSPECTION_SUBCONTRACTOR_NO_SHOW": "Inspection subcontractor no-show",
"INSPECTIONS": "Inspections",
"INSURANCE_ITEMIZATION": "Insurance itemization",
"INSURANCE_PARTNER_FOLLOW_UP": "Insurance partner follow-up",
"INSURANCE_PAYMENT": "Insurance payment",
"INTERIOR_DAMAGE": "Interior damage",
"INTERNAL_FOLLOW_UP": "Internal follow-up",
"INVESTIGATE_WORKMANSHIP_AND_SCHEDULE_REPAIR": "Investigate workmanship and schedule repair",
"INVOICE_REQUEST": "Invoice request",
"LEAKS_INTERIOR_DAMAGE": "Leaks / interior damage",
"LEGAL": "Legal",
"LETTER_OF_AUTHORIZATION": "Letter of authorization",
"LICENSING_BOARD": "Licensing board",
"MATERIAL_REQUEST": "Material request",
"MATERIALS_DELAY": "Materials delay",
"MISC_COMMUNICATION_WITH_HOMEOWNER": "Misc. communication with homeowner",
"MISSING_INFO_FROM_SUBCONTRACTOR": "Missing info from subcontractor",
"MISSING_SOW_INFO": "Missing SOW info",
"NEED_SOW_CONFIRMATION": "Need SOW confirmation",
"NEED_TO_FINALIZE_SALES_PROCESS": "Need to finalize sales process",
"NEED_TO_SCHEDULE_APPOINTMENT": "Need to schedule appointment",
"NEEDS_REASSIGNMENT": "Needs reassignment",
"NEWS_MEDIA": "News media",
"NO_ACTION_NEEDED": "No action needed",
"NO_CALL_NO_SHOW": "No call no show",
"NO_SALES_FOLLOW_UP_SCHEDULED": "No sales follow-up scheduled",
"NTP_DECISION": "NTP decision",
"NTP_ISSUE": "NTP issue",
"OBTAIN_MISSING_PHOTOS": "Obtain missing photos",
"OPEN_ESCALATION": "Open escalation",
"ORDER_MATERIALS": "Order materials",
"OTHER": "Other",
"PARTNER_HIC": "Partner HIC",
"PAYMENT_INQUIRY": "Payment inquiry",
"PENDING_HOA_APPROVAL": "Pending HOA approval",
"PERMIT_FINAL_INSPECTION": "Permit / final inspection",
"PERMIT_INSPECTION_ISSUE": "Permit / inspection issue",
"PERMITTING": "Permitting",
"PLACE_WORK_ON_HOLD": "Place work on hold",
"POOR_WORKMANSHIP": "Poor workmanship",
"PORTAL_INTEGRATION_ISSUE": "Portal / integration issue",
"PRE_EXISTING_PERMITS": "Pre-existing permits",
"PROCESS_CANCELLATION": "Process cancellation",
"PROCESS_FEEDBACK": "Process feedback",
"PROCESS_REFUND_ADJUSTMENT": "Process refund/adjustment",
"PROCESS_SOW_CHANGE": "Process SOW change",
"PRODUCE_ITEMIZED_RECEIPT_INVOICE": "Produce itemized receipt/invoice",
"PROVIDE_CAD_STAMP_LOA": "Provide CAD/stamp/LOA",
"PROVIDE_CAD": "Provide CAD",
"PROVIDE_CUSTOMER_UPDATE": "Provide homeowner update",
"PROVIDE_ESTIMATE_CLARIFICATION": "Provide estimate clarification",
"PROVIDE_INSURANCE_ITEMIZATION": "Provide insurance itemization",
"PROVIDE_LOA": "Provide LOA",
"PROVIDE_REQUESTED_DOCUMENTS": "Provide requested documents",
"PROVIDE_STAMP": "Provide stamp",
"PROVIDE_UPDATE": "Provide update",
"QUOTE_ISSUE": "Quote issue",
"REASSIGN_SUBCONTRACTOR": "Reassign subcontractor",
"RECORD_FEEDBACK": "Record feedback",
"RECORD_PAYMENT": "Record payment",
"REDESIGN": "Redesign",
"REFERRAL_CONTRACTOR_FOLLOW_UP": "Referral contractor follow-up",
"REFERRAL_CORPORATE_PARTNER_FOLLOW_UP": "Referral corporate partner follow-up",
"REFERRAL_HOMEOWNER_FOLLOW_UP": "Referral homeowner follow-up",
"REFERRAL_INTERNAL_FOLLOW_UP": "Referral internal follow-up",
"REFERRAL_PROCESS_FEEDBACK": "Referral process feedback",
"REFERRAL_SALES_FOLLOW_UP": "Referral sales follow-up",
"REFERRAL_SUBCONTRACTOR_FEEDBACK": "Referral subcontractor feedback",
"REFUND_REQUEST": "Refund request",
"REINSTATE_CANCELLED_JOB": "Reinstate cancelled job",
"REJECT_FINDINGS": "Reject findings",
"RELATIONSHIP_ESCALATION": "Relationship escalation",
"REMINDER_CONTRACTOR_FOLLOW_UP": "Reminder contractor follow-up",
"REMINDER_CORPORATE_PARTNER_FOLLOW_UP": "Reminder corporate partner follow-up",
"REMINDER_HOMEOWNER_FOLLOW_UP": "Reminder homeowner follow-up",
"REMINDER_INTERNAL_FOLLOW_UP": "Reminder internal follow-up",
"REMINDER_SALES_FOLLOW_UP": "Reminder sales follow-up",
"REPORT_SAFETY_CONCERN_AND_PAUSE_WORK": "Report safety concern and pause work",
"REQUEST_FOR_CANCELLATION": "Request for cancellation",
"REQUEST_FOR_QUOTE": "Request for quote",
"REQUEST_FOR_REPAIRS": "Request for repairs",
"REQUEST_FOR_SITE_ASSESSMENT": "Request for site assessment",
"REQUEST_FOR_UNCANCELLATION": "Request for uncancellation",
"REQUEST_FOR_UPDATE": "Request for update",
"REQUEST_REPORTABLE_FSD": "Request reportable FSD",
"REQUEST_NEW_ITEL_SITE_VISIT": "Request new iTEL site visit",
"REQUEST_REPORTING_DELAY": "Request reporting delay",
"REQUEST_TO_RESUME_WORK": "Request to resume work",
"RERUN_CUSTOMER_CREDIT": "Rerun customer credit",
"REQUESTED_HOLD_DELAY": "Requested hold / delay",
"RESCHEDULE": "Reschedule",
"RESOLVE_FUNDING_NOT_FINALIZED": "Resolve funding not finalized",
"RESOLVE_SCOPE_DISPUTE": "Resolve scope dispute with homeowner",
"RESOLVE_SCOPE_DISPUTE_WITH_CONTRACTOR": "Resolve scope dispute with contractor",
"REVIEW_ESTIMATED_START_WEEK_EXPECTATIONS": "Review estimated start week expectations",
"REVIEW_REOPENED_BID": "Review reopened bid",
"REVISE_QUOTE_ESTIMATE": "Revise quote/estimate",
"RESPOND_TO_BBB_LICENSING_AG": "Respond to BBB/licensing/AG",
"RESUME_WORK": "Resume work",
"ROOF_LEAK": "Roof leak",
"ROOF_MATERIAL_DAMAGE": "Roof material damage",
"SALES_FOLLOW_UP": "Sales follow-up",
"SALES_FOLLOW_UP_CALL": "Sales follow-up call",
"SALES_FOLLOW_UP_EMAIL": "Sales follow-up email",
"SALES_FOLLOW_UP_OTHER": "Sales follow-up other",
"SALES_FOLLOW_UP_SMS": "Sales follow-up SMS",
"SALES_FOLLOWUP_PARTNER_CANCELLATION": "Sales follow-up partner cancellation",
"SALES_TRAINING": "Sales training",
"SCHEDULE_CLEANUP": "Schedule cleanup",
"SCHEDULE_DAMAGE_ASSESSMENT": "Schedule damage assessment",
"SCHEDULE_LEAK_ASSESSMENT": "Schedule leak assessment",
"SCHEDULE_POST_INSTALL_INSPECTION": "Schedule post-install inspection",
"SCHEDULE_SITE_VISIT_REINSPECTION": "Schedule site visit reinspection",
"SCHEDULE_TRAINING": "Schedule training",
"SCHEDULE_WORK": "Schedule work",
"SCHEDULING": "Scheduling",
"SCOPE_DISPUTE": "Scope dispute",
"SEND_INVOICE": "Send invoice",
"SEND_REMINDER_TO_STAKEHOLDER": "Send reminder to stakeholder",
"SETTLE_FIRST_JOB_PRICE_REJECTION": "Settle first job price rejection",
"SHIP_MATERIALS": "Submit material request FSA",
"TRACK_MATERIAL_REQUEST": "Track material request",
"ESCALATE_MATERIAL_REQUEST_FSA": "Escalate material request FSA",
"REVIEW_POST_NTP_SUNRUN_WO": "Review new Post-NTP Sunrun WO",
"COORDINATE_CREW_PARTNER_MATERIALS_PICKUP": "Coordinate crew to pick up partner materials",
"COMMUNICATE_WITH_PARTNER_RE_QUOTE": "Communicate with partner regarding quote/estimate",
"REQUEST_NEW_ASSIGNMENT_SHELL": "Request new assignment shell",
"PROCESS_SITE_VISIT_CANCELLATION": "Process site visit cancellation",
"RESOLVE_FUNDING_STIPULATIONS": "Resolve funding stipulations",
"RESOLVE_FAILED_SUNRUN_AUTOMATION": "Resolve failed Sunrun automation",
"SUNRUN_FINANCING": "Sunrun financing",
"SUNRUN_FINDINGS_REJECTION": "Sunrun findings rejection",
"SUNRUN_INVOICE_REJECTION": "Sunrun invoice rejection",
"CONFIRM_PHYSICAL_CHECK_RECEIPT": "Confirm receipt of physical check",
"REQUEST_WESTHILL_PAYMENT_WITHOUT_COC": "Request payment from Westhill without CoC",
"SUBMIT_WESTHILL_INVOICE_COC": "Submit Westhill invoice/CoC",
"REVIEW_COLLECTIONS_ITEM": "Review collections item",
"SOCIAL_MEDIA": "Social media",
"SOURCE_CONTRACTOR": "Source contractor",
"SOW_CHANGE_ISSUE": "SOW change issue",
"SOW_CHANGES": "SOW changes",
"SOW_CLARIFICATION": "SOW clarification",
"SOW_DISCREPANCIES": "SOW discrepancies",
"SOW_QUESTIONS": "SOW questions",
"STATUS_UPDATE": "Status update",
"STRUCTURAL_DAMAGE": "Structural damage",
"SUBCONTRACTOR_FEEDBACK": "Subcontractor feedback",
"SUBCONTRACTOR_NO_SHOW": "Subcontractor no-show",
"UNAUTHORIZED_REQUEST": "Unauthorized request",
"UNPERMITTED_STRUCTURE": "Unpermitted structure",
"UNRESPONSIVE_CREW": "Unresponsive crew",
"UNSATISFIED_HOMEOWNER": "Unsatisfied homeowner",
"UPDATE_CONTACT_INFORMATION": "Update contact information",
"UPDATE_REMI_APP": "Update Remi app",
"UPDATE_WORK_ORDER": "Update work order",
"VIP_ACCOUNT": "VIP account",
"WARRANTY_COVERAGE_QUESTION": "Warranty coverage question",
"WESTHILL_FNOL_APPROVAL_OVERDUE": "Westhill FNOL approval overdue",
"WORK_AVAILABILITY_CHECK": "Work availability check",
"WORK_RESCHEDULE": "Work reschedule",
"WORK_SUBCONTRACTOR_NO_SHOW": "Work subcontractor no-show",
"WORKMANSHIP": "Workmanship (active escalation)",
"WORKMANSHIP_COMPLAINT": "Workmanship complaint",
"WRONG_MATERIALS_USED": "Wrong materials used",
"PIPELINE_MANAGEMENT": "Pipeline management",
"PROJECT_COMPLETION_CALL": "Project completion call",
"SOURCE_SPECIALTY_PRICING": "Source specialty pricing",
"SALES_OPERATIONS_PARTNERS_QUESTION": "Sales operations partners question", } satisfies Record<TicketSubcategory, string>;
